export const EntityType = {
    PERSONA: "persona",
};